/* Anonymous website analytics — visit + high-intent beacons.
 * Stores only a random localStorage UUID; no personal data leaves the browser.
 * Each beacon fires at most once per browser session (sessionStorage guard).
 */

const API = process.env.REACT_APP_BACKEND_URL;
const VID_KEY = "wl_vid";

function getVisitorId() {
  try {
    let v = window.localStorage.getItem(VID_KEY);
    if (!v) {
      v = window.crypto?.randomUUID
        ? window.crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      window.localStorage.setItem(VID_KEY, v);
    }
    return v;
  } catch {
    return "anon";
  }
}

function post(path, body) {
  fetch(`${API}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    keepalive: true,
  }).catch(() => {});
}

/** Fires once per browser session when a real page loads. */
export function trackVisit(pagePath) {
  try {
    if (window.sessionStorage.getItem("wl_visit_beacon")) return;
    window.sessionStorage.setItem("wl_visit_beacon", "1");
  } catch {
    return;
  }
  post("/api/analytics/visit", { session_id: getVisitorId(), path: pagePath || "/" });
}

/** High-intent moments: "booking_form" (dwelled on the form) and
 * "availability_check" (adjusted dates/search). Once per session per kind. */
export function trackIntent(kind) {
  try {
    const k = `wl_intent_${kind}`;
    if (window.sessionStorage.getItem(k)) return;
    window.sessionStorage.setItem(k, "1");
  } catch {
    return;
  }
  post("/api/analytics/intent", { session_id: getVisitorId(), kind });
}
